import sanitize from 'sanitize-html';

// Rich text must be sanitized on both the server and client before being injected.
// sanitize-html runs identically in Node and the browser, so SSR and hydration stay consistent.
// Keep HTML formatting, images, and links, but strip scripts, event handlers, and unsafe URLs.
const DEFAULT_ALLOWED_TAGS = [...sanitize.defaults.allowedTags, 'img'];
// Server-rendered links (e.g. feed descriptions) carry a title attribute, which sanitize-html strips by default.
const DEFAULT_ALLOWED_ATTRIBUTES = { ...sanitize.defaults.allowedAttributes, a: ['href', 'name', 'target', 'title'] };

const sanitizeHtml = (html: string, config?: { ALLOWED_TAGS: string[] }): string =>
  sanitize(html, {
    allowedTags: config?.ALLOWED_TAGS ?? DEFAULT_ALLOWED_TAGS,
    allowedAttributes: DEFAULT_ALLOWED_ATTRIBUTES
  });

export default sanitizeHtml;
